"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SectionPropertiesManipulator = void 0;
var tslib_1 = require("tslib");
var search_1 = require("@devexpress/utils/lib/utils/search");
var section_formatting_changed_1 = require("../changes/model/section-formatting-changed");
var history_item_state_1 = require("../history/states/history-item-state");
var history_item_state_object_1 = require("../history/states/history-item-state-object");
var control_1 = require("../options/control");
var section_property_descriptor_1 = require("../section/section-property-descriptor");
var base_manipulator_1 = require("./base-manipulator");
var SectionPropertiesManipulator = (function (_super) {
    tslib_1.__extends(SectionPropertiesManipulator, _super);
    function SectionPropertiesManipulator(manipulator) {
        var _this = _super.call(this, manipulator) || this;
        _this.landscape = new SectionPropertiesLandscapeManipulator(manipulator, section_property_descriptor_1.SectionPropertyDescriptor.landscape);
        _this.marginBottom = new SectionPropertiesManipulatorBase(manipulator, section_property_descriptor_1.SectionPropertyDescriptor.marginBottom);
        _this.marginLeft = new SectionPropertiesManipulatorBase(manipulator, section_property_descriptor_1.SectionPropertyDescriptor.marginLeft);
        _this.marginRight = new SectionPropertiesManipulatorBase(manipulator, section_property_descriptor_1.SectionPropertyDescriptor.marginRight);
        _this.marginTop = new SectionPropertiesManipulatorBase(manipulator, section_property_descriptor_1.SectionPropertyDescriptor.marginTop);
        _this.columnCount = new SectionPropertiesManipulatorBase(manipulator, section_property_descriptor_1.SectionPropertyDescriptor.columnCount);
        _this.columnsInfo = new SectionPropertiesManipulatorBase(manipulator, section_property_descriptor_1.SectionPropertyDescriptor.columnsInfo);
        _this.equalWidthColumns = new SectionPropertiesManipulatorBase(manipulator, section_property_descriptor_1.SectionPropertyDescriptor.equalWidthColumns);
        _this.pageHeight = new SectionPropertiesManipulatorBase(manipulator, section_property_descriptor_1.SectionPropertyDescriptor.pageHeight);
        _this.pageWidth = new SectionPropertiesManipulatorBase(manipulator, section_property_descriptor_1.SectionPropertyDescriptor.pageWidth);
        _this.space = new SectionPropertiesManipulatorBase(manipulator, section_property_descriptor_1.SectionPropertyDescriptor.space);
        _this.startType = new SectionPropertiesManipulatorBase(manipulator, section_property_descriptor_1.SectionPropertyDescriptor.startType);
        _this.differentFirstPage = new SectionPropertiesManipulatorBase(manipulator, section_property_descriptor_1.SectionPropertyDescriptor.differentFirstPage);
        _this.headerOffset = new SectionPropertiesManipulatorBase(manipulator, section_property_descriptor_1.SectionPropertyDescriptor.headerOffset);
        _this.footerOffset = new SectionPropertiesManipulatorBase(manipulator, section_property_descriptor_1.SectionPropertyDescriptor.footerOffset);
        _this.paperKind = new SectionPropertiesManipulatorBase(manipulator, section_property_descriptor_1.SectionPropertyDescriptor.paperKind);
        return _this;
    }
    return SectionPropertiesManipulator;
}(base_manipulator_1.BaseManipulator));
exports.SectionPropertiesManipulator = SectionPropertiesManipulator;
var SectionPropertiesManipulatorBase = (function () {
    function SectionPropertiesManipulatorBase(manipulator, descriptor) {
        this.manipulator = manipulator;
        this.descriptor = descriptor;
    }
    SectionPropertiesManipulatorBase.prototype.setValue = function (interval, newValue) {
        var oldState = new history_item_state_1.HistoryItemState();
        if (!control_1.ControlOptions.isEnabled(this.manipulator.model.options.sections))
            return oldState;
        var newState = new history_item_state_1.HistoryItemState();
        var endPosition = Math.max(interval.start, interval.end - 1);
        var sections = this.manipulator.model.sections;
        var startSectionIndex = search_1.SearchUtils.normedInterpolationIndexOf(sections, function (section) { return section.startLogPosition.value; }, interval.start);
        var endSectionIndex = interval.length ?
            search_1.SearchUtils.normedInterpolationIndexOf(sections, function (section) { return section.startLogPosition.value; }, endPosition) :
            startSectionIndex;
        for (var i = startSectionIndex; i <= endSectionIndex; i++) {
            var section = sections[i];
            oldState.register(new history_item_state_object_1.HistoryItemSectionStateObject(i, this.descriptor.getProp(section.sectionProperties)));
            newState.register(new history_item_state_object_1.HistoryItemSectionStateObject(i, newValue));
            this.setPropertyValue(section.sectionProperties, newValue);
        }
        this.manipulator.notifyModelChanged(new section_formatting_changed_1.SectionsFormattingChangedModelChange(startSectionIndex, endSectionIndex, this.descriptor.getJSONProperty(), newState));
        return oldState;
    };
    SectionPropertiesManipulatorBase.prototype.restoreValue = function (state) {
        if (!control_1.ControlOptions.isEnabled(this.manipulator.model.options.sections))
            return;
        if (state.isEmpty())
            return;
        var sections = this.manipulator.model.sections;
        for (var i = 0, stateObject; stateObject = state.objects[i]; i++) {
            var section = sections[stateObject.sectionIndex];
            this.setPropertyValue(section.sectionProperties, stateObject.value);
        }
        var startSectionIndex = state.objects[0].sectionIndex;
        var endSectionIndex = state.lastObject.sectionIndex;
        this.manipulator.notifyModelChanged(new section_formatting_changed_1.SectionsFormattingChangedModelChange(startSectionIndex, endSectionIndex, this.descriptor.getJSONProperty(), state));
    };
    SectionPropertiesManipulatorBase.prototype.setPropertyValue = function (properties, value) {
        this.descriptor.setProp(properties, value);
    };
    return SectionPropertiesManipulatorBase;
}());
var SectionPropertiesLandscapeManipulator = (function (_super) {
    tslib_1.__extends(SectionPropertiesLandscapeManipulator, _super);
    function SectionPropertiesLandscapeManipulator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SectionPropertiesLandscapeManipulator.prototype.setPropertyValue = function (properties, value) {
        var _a;
        if (properties.landscape !== value) {
            properties.landscape = value;
            _a = [properties.pageHeight, properties.pageWidth], properties.pageWidth = _a[0], properties.pageHeight = _a[1];
        }
    };
    return SectionPropertiesLandscapeManipulator;
}(SectionPropertiesManipulatorBase));
